"use client";

import { c as _c } from "react/compiler-runtime";
import { LocaleName } from "@/app/i18n/settings";
import { AddressWithLocation, AdvertiserLocationWithCompany, GeoLocation } from "@/types/location";
import { useTranslation } from "@/app/i18n/client";
import { Suspense, useState } from "react";
import MapContainer from "@/components/Util/Map/MapContainer";
import { AddressInputSearch } from "../../../_components/Forms/address-input-search";
import LoadingSpinnerBlock from "@/components/LoadingSpinner/LoadingSpinnerBlock";
import { Modal } from "@/components/Util/Modal";
import { MarkerType } from "@/components/Util/Map/Map";
import { HeadingBlockAction } from "../../_components/HeadingBlock";
import AdvertiserDetailList from "./AdvertiserDetailsList";
import AdvertiserTable from "./AdvertiserTable";
import { AdvertiserCarouselSkeleton } from "@/app/[lng]/_components/advertiser-carousel-skeleton";
import { api } from "@/utils/trpc/react";
import { AdvertiserCarousel } from "@/app/[lng]/_components/advertiser-carousel";
export function AdPartnerFilter(t0) {
  const $ = _c(55);
  const {
    lng
  } = t0;
  const [startLocation, setStartLocation] = useState();
  const [endLocation, setEndLocation] = useState();
  const [showMarkerInfo, setShowMarkerInfo] = useState(false);
  const [currentLocations, setCurrentLocations] = useState();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["advertiser", "common"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== endLocation || $[2] !== startLocation) {
    t2 = {
      startLocation,
      endLocation,
      notGrouped: true
    };
    $[1] = endLocation;
    $[2] = startLocation;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    data: advertisers,
    isLoading,
    isError
  } = api.advertiserlocation.GetStartpageAdvertisers.useQuery(t2);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = address => {
      if (address) {
        setStartLocation({
          latitude: address.location.latitude,
          longitude: address.location.longitude
        });
        setEndLocation({
          latitude: address.location.latitude,
          longitude: address.location.longitude
        });
      } else {
        setStartLocation(undefined);
        setEndLocation(undefined);
      }
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const onAddressChange = t3;
  let t4;
  if ($[5] !== advertisers) {
    t4 = locationId => {
      if (locationId) {
        const location = advertisers?.filter(loc => loc.advertiserLocation.id === locationId);
        if (location && location.length > 0) {
          setCurrentLocations(location);
          setShowMarkerInfo(true);
        }
      }
    };
    $[5] = advertisers;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const showSingleMarkerModal = t4;
  let t5;
  if ($[7] !== advertisers) {
    t5 = locationIds => {
      if (locationIds) {
        const locations = advertisers?.filter(loc_0 => locationIds.includes(loc_0.advertiserLocation.id));
        if (locations && locations.length > 0) {
          setCurrentLocations(locations);
          setShowMarkerInfo(true);
        }
      }
    };
    $[7] = advertisers;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const showClusterModal = t5;
  let t6;
  if ($[9] !== t) {
    t6 = t("SEARCH.PLACEHOLDER");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== lng || $[12] !== t6) {
    t7 = <HeadingBlockAction className=""><AddressInputSearch lng={lng} id="Tipps" type="locality" placeholder={t6} onAddressChange={onAddressChange} className="mx-auto max-w-full lg:max-w-[500px]" /></HeadingBlockAction>;
    $[11] = lng;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== advertisers) {
    t8 = advertisers?.map(_temp) ?? [];
    $[14] = advertisers;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== showClusterModal || $[17] !== showSingleMarkerModal || $[18] !== t8) {
    t9 = <MapContainer showClusterModal={showClusterModal} showSingleMarkerModal={showSingleMarkerModal} visibleItems={t8} hideSearchField={true} type={MarkerType.Advertiser} height="500px" />;
    $[16] = showClusterModal;
    $[17] = showSingleMarkerModal;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== advertisers || $[21] !== isError || $[22] !== isLoading || $[23] !== lng || $[24] !== t) {
    t10 = isLoading ? <LoadingSpinnerBlock small={true} /> : isError ? <div>{t("common:ERRORLOADING")}</div> : <AdvertiserTable advertisers={advertisers} lng={lng} />;
    $[20] = advertisers;
    $[21] = isError;
    $[22] = isLoading;
    $[23] = lng;
    $[24] = t;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t10 || $[27] !== t9) {
    t11 = <div className="mb-8">{t9}{t10}</div>;
    $[26] = t10;
    $[27] = t9;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t) {
    t12 = t("common:MAIN.HOMEV2.TIPS_FROM_EDITORIAL_STAFF.TITLE");
    $[29] = t;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t12) {
    t13 = <h2>{t12}</h2>;
    $[31] = t12;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <AdvertiserCarouselSkeleton />;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== endLocation || $[35] !== startLocation) {
    t15 = <Suspense fallback={t14}><AdvertiserCarousel startLocation={startLocation} endLocation={endLocation} /></Suspense>;
    $[34] = endLocation;
    $[35] = startLocation;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== t13 || $[38] !== t15) {
    t16 = <div>{t13}{t15}</div>;
    $[37] = t13;
    $[38] = t15;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] !== t) {
    t17 = t("common:COMPANYTYPES.ADVERTISER");
    $[40] = t;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = () => {
      setShowMarkerInfo(false);
    };
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== currentLocations || $[44] !== lng) {
    t19 = <div className="h-full max-h-[80vh] overflow-y-auto"><AdvertiserDetailList advertisers={currentLocations} lng={lng} /></div>;
    $[43] = currentLocations;
    $[44] = lng;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] !== showMarkerInfo || $[47] !== t17 || $[48] !== t19) {
    t20 = <Modal header={t17} modalDidClose={t18} open={showMarkerInfo} className="max-h-[100vh] w-full overflow-hidden rounded-sm lg:w-fit">{t19}</Modal>;
    $[46] = showMarkerInfo;
    $[47] = t17;
    $[48] = t19;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  let t21;
  if ($[50] !== t11 || $[51] !== t16 || $[52] !== t20 || $[53] !== t7) {
    t21 = <>{t7}{t11}{t16}{t20}</>;
    $[50] = t11;
    $[51] = t16;
    $[52] = t20;
    $[53] = t7;
    $[54] = t21;
  } else {
    t21 = $[54];
  }
  return t21;
}
function _temp(alwc) {
  return alwc.advertiserLocation;
}